
import { openDB } from 'idb';

const DB_NAME = 'E-candidate';
const DB_VERSION = 1;
const STORE = 'kv';   // key–value แบบง่าย


let dbPromise;

async function getDB() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(STORE)) {
                    db.createObjectStore(STORE); // key = string, value = anything
                }
            }
        });
    }
    return dbPromise;
}

/** Save a value */
export async function setItem(key, value) {
    try {
        const db = await getDB();
        console.log("[setItem] saving key:", key, "value:", value);
        await db.put(STORE, value, key); // Save the value with the specified key
    } catch (error) {
        console.error("[setItem] Error saving value:", error);
    }
}

/** Read a value */
export async function getItem(key) {
    try {
        const db = await getDB();
        const value = await db.get(STORE, key); // Retrieve the value by key
        console.log("[getItem] retrieved key:", key, "value:", value);
        return value;
    } catch (error) {
        console.error("[getItem] Error retrieving value:", error);
        return null; // Return null if error occurs
    }
}

/** Remove a value */
export async function removeItem(key) {
    try {
        const db = await getDB();
        console.log("[removeItem] deleting key:", key);
        await db.delete(STORE, key); // Delete the value by key
    } catch (error) {
        console.error("[removeItem] Error removing value:", error);
    }
}